function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import FoldersAndFilesRow from './FoldersAndFilesRow';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import DraggableElement from '../util/draggable_element/DraggableElement';
import FolderAndFileTableHeading from './FolderAndFileTableHeading';
const FolderFileDragContainer = _ref => {
  let {
    folders,
    files,
    setFolders,
    setFiles,
    setCurrentFolderId,
    showFolderOrFileDropModal,
    setDraggedElement,
    draggedElement,
    setCurrentAction,
    goToFolderQuery,
    canEditExistingDocumentsOrFolders = true
  } = _ref;
  const {
    t
  } = useTranslation();
  const handleDragStart = data => {
    setDraggedElement(_objectSpread({}, data));
  };
  const renderFolderRows = folders.map(f => {
    return /*#__PURE__*/React.createElement(DraggableElement, {
      userCanDrag: canEditExistingDocumentsOrFolders,
      key: (f.id || f.model_id) + f.name,
      element: f,
      onDragStart: handleDragStart,
      onDrop: showFolderOrFileDropModal,
      setDraggedElement: setDraggedElement,
      draggedElement: draggedElement,
      setCurrentAction: setCurrentAction
    }, /*#__PURE__*/React.createElement(FoldersAndFilesRow, {
      data: f,
      route: 'folders',
      setAllData: setFolders,
      allData: folders,
      setCurrentFolderId: setCurrentFolderId,
      goToFolderQuery: goToFolderQuery,
      canEditExistingDocumentsOrFolders: canEditExistingDocumentsOrFolders
    }));
  });
  const renderFileRows = files.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).map(f => {
    return /*#__PURE__*/React.createElement(DraggableElement, {
      userCanDrag: canEditExistingDocumentsOrFolders,
      key: f.id + f.name + 'files',
      element: f,
      onDragStart: handleDragStart,
      onDrop: showFolderOrFileDropModal,
      setDraggedElement: setDraggedElement,
      draggedElement: draggedElement,
      setCurrentAction: setCurrentAction
    }, /*#__PURE__*/React.createElement(FoldersAndFilesRow, {
      data: f,
      route: 'folder_files',
      setAllData: setFiles,
      allData: files,
      canEditExistingDocumentsOrFolders: canEditExistingDocumentsOrFolders
    }));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    className: "table borderless"
  }, /*#__PURE__*/React.createElement(FolderAndFileTableHeading, null), /*#__PURE__*/React.createElement("tbody", null, renderFolderRows, renderFileRows)));
};
export default FolderFileDragContainer;